import { logError } from './logError'

export type WalkthroughState = {
    dismissed: boolean
    currentStep: number
    completed: boolean
}

const STORAGE_KEY = 'app-walkthrough-state'

const DEFAULT_STATE: WalkthroughState = {
    dismissed: false,
    currentStep: 0,
    completed: false,
}

export const getWalkthroughState = (): WalkthroughState => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY)
        if (!stored) {
            return DEFAULT_STATE
        }

        const parsed = JSON.parse(stored) as Partial<WalkthroughState>
        return {
            dismissed: parsed.dismissed ?? DEFAULT_STATE.dismissed,
            currentStep: parsed.currentStep ?? DEFAULT_STATE.currentStep,
            completed: parsed.completed ?? DEFAULT_STATE.completed,
        }
    } catch (error) {
        logError(error, {
            source: 'appWalkthroughStorage.getWalkthroughState',
            operation: 'getWalkthroughState',
            storageKey: STORAGE_KEY,
        })
        return DEFAULT_STATE
    }
}

export const saveWalkthroughState = (state: WalkthroughState): void => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch (error) {
        logError(error, {
            source: 'appWalkthroughStorage.saveWalkthroughState',
            operation: 'saveWalkthroughState',
            storageKey: STORAGE_KEY,
            state,
        })
    }
}

export const resetWalkthroughState = (): void => {
    try {
        localStorage.removeItem(STORAGE_KEY)
    } catch (error) {
        logError(error, {
            source: 'appWalkthroughStorage.resetWalkthroughState',
            operation: 'resetWalkthroughState',
            storageKey: STORAGE_KEY,
        })
    }
}
